export default {
  DataManutencao: {
    label: 'fields.engineering.commutator-maintenance.maintenance-date',
  },
  DataHoraManutencao: {
    label: 'fields.engineering.commutator-maintenance.maintenance-date',
  },
  Duracao: {
    label: 'fields.engineering.commutator-maintenance.duration',
  },
  ComutacoesRestantesAvisoManutencao: {
    label: 'fields.engineering.commutator-maintenance.remaining-commutations',
  },
  DiasDeAntecedenciaAvisoManutencao: {
    label: 'fields.engineering.commutator-maintenance.days-advance-maintenance-notice',
  },
  TempoTotalServico: {
    label: 'fields.engineering.commutator-maintenance.total-service-time',
  },
  NumeroManutencoesRealizadas: {
    label: 'fields.engineering.commutator-maintenance.performed-maintenance-number',
  },
};
